module.exports = __webpack_public_path__ + "ui-static/img/videos-no-items_light.3d4bcf82.svg";